module.exports = __webpack_public_path__ + "media/images/new/roadpass_pro@2x-c5eb763377535665891d865fcee1d64a.jpg";